import { Grid, IconButton, Tooltip } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { MdArrowBack } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import PrimeTable from '../../../components/PrimeTable'
import ModalSelecionaPontoVenda from '../pontoDeVenda/modal/modalSelecionaPontoVenda'
import { BsPlus, BsShopWindow } from 'react-icons/bs'
import { metodoPrograma } from '../../../components/api'
import Edicao from './Edicao'
import ModalSelecionaAtendimento from './modalSelecionaAtendimento'
import { useModal } from '../../../components/Utils/UseModal'
import { setError } from '../../../components/alerts'

export const STATUS_MAP = {
  0: { label: 'Rascunho', color: '#1976d2', background: '#e3f2fd' },
  3: { label: 'Em Atendimento', color: '#a7a7a7', background: '#f9f9f9' },
  9: {
    label: 'Finalizado',
    color: '#02a50a',
    background: '#e2ffe1',
  },
}

export function StatusChip({ status }) {
  const info = STATUS_MAP[status]

  if (!info) return status

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 600,
        width: '100%',
        color: info.color,
        backgroundColor: info.background,
        textAlign: 'center',
      }}
    >
      {info.label}
    </span>
  )
}

const Checkout = () => {
  const { localAtendimento } = useContext(GlobalContext)

  const modalSelecionaAtendimento = useModal(ModalSelecionaAtendimento)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)

  const { lojaPontoVenda } = useContext(GlobalContext)

  const [openModal, setOpenModal] = useState(!lojaPontoVenda?.idPontoVenda)

  const voltar = () => {
    setTela('lista')
  }

  const crirarCheckinPorAtendimento = async () => {
    const selected = await modalSelecionaAtendimento()

    if (!selected) return

    const { result } = await metodoPrograma('buscaCheckoutPorAtendimento', {
      idAtendimento: selected[0],
    })

    result[13] = selected?.[11] || ''

    setDados({ linha: result })
    setTela('opcoes')
  }

  const handleClick = async (linha) => {
    const { result, status } = await metodoPrograma(
      'buscaCheckoutPorAtendimento',
      {
        idAtendimento: linha[0],
      },
    )
    if (!status) return setError('Problema ao carregar Checkout!')

    result[13] = linha?.[11] || ''

    setDados({ linha: result })
    setTela('opcoes')
  }

  useEffect(() => {
    if (tela !== 'lista') {
      setFerramentas(
        <Tooltip title="Voltar">
          <IconButton onClick={voltar}>
            <MdArrowBack />
          </IconButton>
        </Tooltip>,
      )
    } else
      setFerramentas(
        <Tooltip title="Criar checkin por atendimento">
          <span>
            <IconButton onClick={crirarCheckinPorAtendimento}>
              <BsPlus />
            </IconButton>
          </span>
        </Tooltip>,
      )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])
  const handleCloseModal = (id, qtd) => {
    if (id) {
      if (qtd > 1)
        setFerramentas(
          <>
            <Tooltip title="Alterar Ponto de Venda">
              <IconButton onClick={() => setOpenModal(true)}>
                <BsShopWindow />
              </IconButton>
            </Tooltip>
          </>,
        )
      // setPontoVenda({ id, qtd })
      setOpenModal(false)
    }
  }
  return (
    <Programa codigo="CtrlCheckout" ferramentas={ferramentas}>
      <ModalSelecionaPontoVenda open={openModal} onClose={handleCloseModal} />
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              codigo="CtrlCheckout"
              action="lista"
              rows={10}
              habSearch
              parametros={{ idLocalAtendimento: localAtendimento?.[0] }}
              collumnsDate={[3, 4]}
              collumnsDateHour={[5]}
              collumnsCurrency={[6]}
              head={[
                'Proposta',
                'Contratante',
                'Situação',
                'Checkin',
                'Checkout',
                'Inclusão',
                'Pago',
              ]}
              line={(item) => [
                item[0],
                item[1][1],
                item?.[2] ? <StatusChip status={item[2]} /> : '',
                item[5],
                item[6],
                item[8],
                item[9],
              ]}
              onRowSelect={handleClick}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao dados={dados} voltar={voltar} lojaPontoVenda={lojaPontoVenda} />
      )}
    </Programa>
  )
}

export default Checkout
